<template>
  <v-dialog v-model="visible" max-width="1000">
    <v-card>
      <v-card-title class="text-h6 grey lighten-1">
         <v-avatar class="ml-n2 mr-3">
           <v-img :src="imagenTitulo" />
         </v-avatar>
         {{ objetoAparato.des }}
      </v-card-title>

      <v-card-text class="pa-0">
        <v-tabs v-model="tab" fixed-tabs background-color="#E0E0D0" mobile-breakpoint="0">
          <!-- <v-tabs-slider color="red"></v-tabs-slider> -->
          <v-tab>
            <v-icon class="mr-3">mdi-information-outline</v-icon>{{ $t ('General') }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-3">mdi-comment-processing-outline</v-icon>{{ $t ('Eventos') }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" touchless>

          <!-- G E N E R A L  -->

          <v-tab-item :eager="true">
            <v-container class="pt-8" fluid>
              <v-row dense justify="center">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Identificación') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  {{ $t ('Caja') }} {{estadoAparato.machine_number}} ({{estadoAparato.short_name}})<br>
                  {{estadoAparato.long_name}}<br>
                </v-col>
              </v-row>
              <v-row dense justify="center">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Versión') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  {{estadoAparato.version}}
                </v-col>
              </v-row>
              <v-row v-if="estadoAparato.shift" dense justify="center" class="mt-5">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Turno') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  {{ estadoAparato.safeGet ('shift.number') }}
                  <template v-if="fechaInicioTurno">({{ fechaInicioTurno }})</template>
                </v-col>
              </v-row>
              <v-row dense justify="center">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Estado') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  <v-chip v-if="!estadoAparato.on_line" color="red" outlined class="mr-1 mb-1"><v-icon left>mdi-help-network</v-icon>{{$t ('Off line')}}</v-chip>
                  <v-chip v-if="estadoAparato.out_of_order" color="red" outlined class="mr-1 mb-1"><v-icon left>mdi-close-octagon</v-icon>{{$t ('Fuera de servicio')}}</v-chip>
                  <v-chip v-if="estadoAparato.on_line && !estadoAparato.out_of_order" color="green" outlined class="mr-1 mb-1"><v-icon left>mdi-emoticon-happy-outline</v-icon>{{$t ('Correcto')}}</v-chip>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- E V E N T O S  -->

          <v-tab-item :eager="true">
            <VisorEventosSAGA
              :key="objetoAparato.id_apa"
              :id-instalacion="objetoAparato.id_ins"
              :id-aparato="objetoAparato.id_apa"
              dense
              sin-sombra
            />
          </v-tab-item>

        </v-tabs-items>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="visible = false">
          {{ $t ('Cerrar') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DateTime } from "luxon";
import VisorEventosSAGA from "@/components/VisorEventosSAGA.vue";

export default {
  components: {
                VisorEventosSAGA
              },
  data () {
    return {
      visible: false,
      tab: 0,
      objetoAparato: {},
      estadoAparato: {},
      sagabroker: null,
      fechaUltimasOperaciones: DateTime.now().toFormat("yyyy-MM-dd"),
      cargandoUltimasOperaciones: false,
      literalFechaUltimasOperaciones: '',
      listadoUltimasOperaciones: ''
    }
  },
  computed: {
    imagenTitulo() {
      return process.env.VUE_APP_URL_BASE_FRONTEND + 'assets__static/aparatos/cm.png';
    },
    fechaInicioTurno() {
      if (this.estadoAparato.shift && this.estadoAparato.shift.opening_date_time)
        return DateTime.fromISO (this.estadoAparato.shift.opening_date_time).toFormat ("cccc, dd-MM-yyyy HH:mm");
      else
        return null;
    }
  },
  methods: {
    abrirVentana (objetoAparato, estadoAparato, sagabroker) {
      //this.tab = 0;
      this.objetoAparato = objetoAparato;
      this.estadoAparato = estadoAparato;
      this.sagabroker = sagabroker;
      this.cargandoUltimasOperaciones = false;
      if (this.tab == 3)
        this.actualizarUltimasOperacionesFechaSeleccionada();
      this.visible = true;
    },
    fechaMinima() {
      return DateTime.now().minus({days: 15}).toISO();
    },
    fechaMaxima() {
      return DateTime.now().toISO();
    }
  }
}
</script>

<style scoped>
.fuente-negrita {
  color: black;
  font-weight: bolder;
}
</style>